import { Node } from "@tiptap/pm/model";
import { Editor, NodeViewWrapper } from "@tiptap/react";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { cn } from "../../../lib/utils/index.js";

interface AudioBlockViewProps {
  editor: Editor;
  getPos: () => number;
  node: Node & {
    attrs: {
      src: string;
      poster: string;
      assetId: string;
      playlistUrl?: string;
    };
  };
  updateAttributes: (attrs: Record<string, string>) => void;
}

export type Playlist = {
  id: string;
  title: string;
  description: string;
  poster: string;
  items: Item[];
};

export type Item = {
  src: string;
  type: string;
  label: string;
  width: number;
  height: number;
};

export const AudioBlockView = (props: AudioBlockViewProps) => {
  const { editor, getPos, node } = props;
  const audioWrapperRef = useRef<HTMLDivElement>(null);
  const { src, caption } = node.attrs;

  const wrapperClassName = cn(
    node.attrs.align === "left" ? "ml-0" : "ml-auto",
    node.attrs.align === "right" ? "mr-0" : "mr-auto",
    node.attrs.align === "center" && "mx-auto"
  );

  const onClick = useCallback(() => {
    editor.commands.setNodeSelection(getPos());
  }, [getPos, editor.commands]);

  return (
    <NodeViewWrapper>
      <div className={wrapperClassName} style={{ width: node.attrs.width }}>
        <div ref={audioWrapperRef}>
          <audio
            controls
            className="block"
            src={src}
            //poster={poster}
            title=""
            onClick={onClick}
          />
        </div>
      </div>
    </NodeViewWrapper>
  );
};

export default AudioBlockView;
